import { ActivePhase } from '@/engine/app/CasePhaseData/ActivePhase/ActivePhase.ts';
import { AvailablePhases } from '@/engine/app/CasePhaseData/AvailablePhases/AvailablePhases.ts';
import type { IParamsDescriptor, NamedParams } from '@/engine/app/CasePhaseData/interfaces.ts';
import { action, makeObservable, observable } from 'mobx';

export class KindInfo {
  public activePhase = new ActivePhase();

  public availablePhases = new AvailablePhases();

  public activePhaseIdx = -1;

  public phaseImports = new Array<string>();

  public phaseParamsDescriptor?: Array<IParamsDescriptor> = undefined;

  @observable
  private _params: NamedParams = new Map();

  @observable
  private _isPhaseSwitching = false;

  public constructor() {
    makeObservable(this);
  }

  public getParamsIterator(): IterableIterator<[string, number]> {
    return this._params.entries();
  }

  public getParam(name: string): number | undefined {
    return this._params.get(name);
  }

  @action
  public setParam(name: string, value: number): void {
    this._params.set(name, value);
  }

  public getIsPhaseSwitching(): boolean {
    return this._isPhaseSwitching;
  }

  @action
  public setIsPhaseSwitching(isPhaseSwitching: boolean): void {
    this._isPhaseSwitching = isPhaseSwitching;
  }
}
